module.exports = __webpack_public_path__ + "static/img/flow_top.d39cf83b.svg";